import { Component, ChangeDetectionStrategy, OnChanges, SimpleChanges, Input, HostBinding, OnInit } from '@angular/core';
import { TabModel, TabSize } from '../../types';
import { BaseTabsComponent } from '../base-tabs/base-tabs.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TabsComponent extends BaseTabsComponent implements OnChanges, OnInit {
  @HostBinding('class.multiple-tabs')
  private multipleTabs: boolean;

  @Input()
  tabProgressDisplay = false;

  @Input()
  allowTabTemplates = true;

  @Input()
  disableTabsOnNoItems: boolean;

  @Input()
  tabSize: TabSize = 'medium';

  @Input()
  borderBottom = true;

  @Input()
  noPadingBorderButton = false;

  @Input()
  allowInitTabChange = false;

  @Input()
  renderAllTabs = true;

  @Input()
  useCarousel = false;

  @Input()
  carouselMaxWidthInPercents: number;

  @Input()
  hasAdaptiveWidth = false;

  @Input()
  showTabs = true;

  @Input()
  stretchVertically = false;

  get isShowBottomBorder(): boolean {
    return this.tabs?.length > 1 && this.borderBottom;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);

    if ('showTabs' in changes) {
      this.cd.detectChanges();
    }

    if ('tabs' in changes && this.tabs) {
      this.multipleTabs = this.tabs.length > 1;
    }

    if ('selectTabById' in changes && this.selectTabById && this.tabs) {
      if (this.allowInitTabChange && changes['selectTabById'].isFirstChange()) {
        this.tabChange.emit(this.tabs[this.selectedTabIndex].tabId);
      }
    }
  }

  isTabDisplayed(tab: TabModel): boolean {
    return !tab.displayCondition || tab.displayCondition();
  }

  isTabDisabled(tab: TabModel): boolean {
    return (this.disableTabsOnNoItems && !tab.count) || (tab.disableCondition && tab.disableCondition());
  }

  getTabToolTipKey(tab: TabModel): string {
    if (tab.disableCondition && tab.disableCondition() && tab.disabledToolTip) {
      return tab.disabledToolTip;
    }

    return tab.tooltipText;
  }

  tabTrackBy(_: number, tab: TabModel): any {
    return tab.tabId;
  }
}
